import { useState, useEffect } from 'react'
import { fetchUserRepos } from '../services/github'

export const useGithubRepos = (username, { limit, excludeForks = true } = {}) => {
  const [repos, setRepos] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    if (!username) {
      setLoading(false)
      return
    }

    const loadRepos = async () => {
      try {
        setLoading(true)
        const data = await fetchUserRepos(username)
        let filtered = excludeForks ? data.filter(repo => !repo.fork) : data
        // Exclude profile README repo (repo name === username)
        filtered = filtered.filter(repo => repo.name.toLowerCase() !== username.toLowerCase())
        // Sort by stars then by updated date
        filtered.sort((a, b) => (b.stargazers_count || 0) - (a.stargazers_count || 0) || new Date(b.updated_at) - new Date(a.updated_at))
        if (limit) filtered = filtered.slice(0, limit)
        setRepos(filtered)
        setError(null)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }
    
    loadRepos()
  }, [username, limit, excludeForks])

  return { repos, loading, error }
} 